import React from "react";
import { ReactComponent as LeftArrow } from "../../resources/icons/left_pointer.svg";
import { ReactComponent as RightArrow } from "../../resources/icons/right_pointer.svg";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  const generatePageNumbers = () => {
    if (totalPages <= 6) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages: (number | string)[] = [];

    pages.push(1);

    if (currentPage > 3) {
      pages.push("...");
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages;
  };

  const pages = generatePageNumbers();

  return (
    <div className="flex justify-between items-center mt-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`flex flex-row items-center ml-4 gap-2 px-3 py-1 border rounded-xl transition-colors ${
          currentPage === 1
            ? "text-[#98A2B3] cursor-not-allowed"
            : "text-[#344054]"
        }`}
      >
        <LeftArrow
          className="w-4 h-4"
          style={{ fill: currentPage === 1 ? "#98A2B3" : "#344054" }}
        />
        Previous
      </button>

      <div className="flex space-x-2">
        {pages.map((page, index) =>
          typeof page === "number" ? (
            <button
              key={index}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1 rounded transition-colors ${
                currentPage === page
                  ? "bg-[#F4F4F4] text-[#344054] font-semibold"
                  : "text-[#475467]"
              }`}
            >
              {page}
            </button>
          ) : (
            <span key={index} className="px-2 text-[#98A2B3]">
              ...
            </span>
          )
        )}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`flex flex-row items-center mr-4 gap-2 px-3 py-1 border rounded-xl transition-colors ${
          currentPage === totalPages
            ? "text-[#98A2B3] cursor-not-allowed"
            : "text-[#344054]"
        }`}
      >
        Next
        <RightArrow
          className="w-4 h-4"
          style={{ fill: currentPage === totalPages ? "#98A2B3" : "#344054" }}
        />
      </button>
    </div>
  );
};

export default Pagination;
